module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/auth/forgot-password/forgot-password.component.css
// module id = ./src/app/auth/forgot-password/forgot-password.component.css
// module chunks = main